import styled from 'styled-components';

import { BORDER_PROPERTIES, FONT_PROPERTIES } from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const SessionLabel = styled.span`
    padding: 0.5rem 0.75rem;
    background-color: ${(props) => props.$backgroundColor};
    cursor: default;
    border-style: solid;
    ${BORDER_PROPERTIES};
    ${FONT_PROPERTIES};
`;
